export enum SearchFocusState {
  SEARCH_INPUT = 'searchInput', // current focus is on the search form
  RESULTS_LIST = 'searchList', // current focus is on the search result list
  SEARCH_TYPE = 'searchType', // current focus is on the search type dropdown
  SEARCH_BUTTON = 'searchButton', // current focus is on the 'search' button
  NONE = 'none', // current focus is not on search
}
